import { ReactNode } from 'react';

import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';

import ViewedTracker from '@components/viewed-tracker/ViewedTracker';

import { TrackingEventName } from '@shared/application/marketing/events/tracking-event-name';

export interface SectionViewedTrackerProps {
  section: string;
  isTest: boolean | null;
  jobPositionId: string;
  isFlagReady?: boolean;
  children: ReactNode;
}

const SectionViewedTracker: React.FC<SectionViewedTrackerProps> = ({ section, isTest, jobPositionId, isFlagReady = true, children }) => {
  const { sourceDomainName: host } = useFlavorFromRoute();

  return (
    <ViewedTracker
      eventName={TrackingEventName.JdpSectionViewed}
      isFlagReady={isFlagReady}
      properties={{ host, jobPositionId, section, variant: isTest ? 'test' : 'control' }}>
      {children}
    </ViewedTracker>
  );
};

export default SectionViewedTracker;
